<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2 langkey="phNewOrderTimeDialog_Title">
    </h2>
    <div class="dialog-description">
      <ng-container *ngIf="!isClosed; then newTimeTemplate else closedTemplate"></ng-container>
      <ng-template #newTimeTemplate>
        <span langkey="phNewOrderTimeDialog_Description"></span>
        <div class="abholzeit-select">
          <div class="ya-input-container-flexwidth">
            <select a11y_Select class="ya-input-text requestServiceTime"
              (change)="setRequestServiceTime($event.currentTarget.value)">
              <ng-container *ngFor="let serviceTime of serviceOpenTimeViewModels; let index = index">
                <option [value]="index"
                  [selected]="selecetedorderTime.value == serviceTime.value && orderASAP == serviceTime.asap">
                  {{serviceTime.display}}</option>
              </ng-container>
            </select>
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
          </div>
        </div>
      </ng-template>
      <ng-template #closedTemplate>
        <span langkey="phNewOrderTimeDialog_Description_Closed"></span>
      </ng-template>
    </div>
    <div class="buttonscontainer">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <ng-container *ngIf="!isClosed">
            <div class="ya-button-container">
              <button mat-flat-button (click)="confirm()">
                <span langkey="phNewOrderTimeDialog_Button_NewTime"></span>
              </button>
            </div>
          </ng-container>
          <div class="ya-button-container">
            <button mat-flat-button (click)="navigateToService()">
              <span langkey="phNewOrderTimeDialog_Button_Close"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>